// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Star Wars Universe - Aliens Configuration
 * 
 * Maps Star Wars alien species to planets.
 * All species must be registered in global AlienSpeciesConfig.js first.
 */

export const StarWarsAliensPlanets = {
  planets: {
    800: ['humancoruscant', 'jedi', 'sith'], // Coruscant
    801: ['jawa', 'tuskenraider', 'hutt'], // Tatooine
    802: ['wampa', 'tauntaun'], // Hoth
    803: ['ewok'], // Endor
    804: ['gungan', 'humannaboo'], // Naboo
    805: ['sith'], // Mustafar (Sith stronghold)
    806: ['yoda'], // Dagobah
    807: ['kaminoan'], // Kamino
    808: [], // Alderaan Memorial (destroyed - keep empty)
    809: ['scavenger'], // Death Star Ruins (scavengers)
    810: ['humanbespin'], // Bespin
    811: ['scavenger'] // Jakku
  },
  randomEncounters: ['jedi', 'sith', 'bountyhunter'],
  hostileSpecies: ['sith', 'tuskenraider', 'wampa'],
  friendlyTraders: ['jawa', 'humancoruscant']
};

export default StarWarsAliensPlanets;
